import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["region", "comuna", "comunaWrapper"];
  static values = {
    states: Array,
    city: String,
  };

  connect() {
    this.updateComunas();
  }

  regionChanged() {
    this.cityValue = "";
    this.updateComunas();
  }

  comunaChanged(event) {
    this.cityValue = event.target.value;
  }

  updateComunas() {
    const selectedRegion = this.regionTarget.value;
    const comunaSelect = this.comunaTarget;

    // Limpiar opciones actuales
    comunaSelect.innerHTML = '<option value="">Seleccionar</option>';

    if (!selectedRegion) {
      this.comunaWrapperTarget.classList.add("hidden");
      return;
    }

    // Buscar la región seleccionada
    const region = this.statesValue.find((r) => r.region === selectedRegion);

    if (region && region.comunas) {
      region.comunas.forEach((comuna) => {
        const option = document.createElement("option");
        option.value = comuna.name;
        option.textContent = comuna.name;
        comunaSelect.appendChild(option);
      });

      if (this.cityValue) {
        comunaSelect.value = this.cityValue;
      }

      this.comunaWrapperTarget.classList.remove("hidden");
    } else {
      this.comunaWrapperTarget.classList.add("hidden");
    }
  }
}
